export default {
  LEFT: 'Left',
  CENTER: 'Center',
  RIGHT: 'Right'
}
